var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("e-sidebar", {
        attrs: {
          title: _vm.edit
            ? _vm.$t("Editar Fornecedor de Delivery")
            : _vm.$t("Novo Fornecedor de Delivery"),
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "500px",
        },
        on: { save: _vm.saveDeliverySupplier, hidden: _vm.hideSidebar },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "FormulateForm",
                  {
                    ref: "deliverySupplierForm",
                    attrs: { name: "deliverySupplierForm" },
                  },
                  [
                    _c("FormulateInput", {
                      staticClass: "required",
                      attrs: {
                        id: "delivery-supplier-name",
                        type: "text",
                        maxlength: "100",
                        label: _vm.$t("Nome"),
                        validation: "required",
                      },
                      model: {
                        value: _vm.localDeliverySupplier.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.localDeliverySupplier, "name", $$v)
                        },
                        expression: "localDeliverySupplier.name",
                      },
                    }),
                    _c("FormulateInput", {
                      staticClass: "required",
                      attrs: {
                        id: "delivery-supplier-supplier",
                        type: "vue-select",
                        label: _vm.$t("Integração"),
                        instruction: _vm.$t(
                          "Serviço externo utilizado para solicitar as entregas deste fornecedor."
                        ),
                        placeholder: _vm.$t("Selecione"),
                        options: _vm.deliverySupplierOptions(),
                        validation: "required",
                      },
                      model: {
                        value: _vm.localDeliverySupplier.supplier,
                        callback: function ($$v) {
                          _vm.$set(_vm.localDeliverySupplier, "supplier", $$v)
                        },
                        expression: "localDeliverySupplier.supplier",
                      },
                    }),
                    _c("FormulateInput", {
                      attrs: {
                        id: "delivery-supplier-active",
                        type: "switch",
                        label: _vm.$t("Ativo"),
                      },
                      model: {
                        value: _vm.localDeliverySupplier.active,
                        callback: function ($$v) {
                          _vm.$set(_vm.localDeliverySupplier, "active", $$v)
                        },
                        expression: "localDeliverySupplier.active",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }